import React, { useState } from "react";

const TasksContext =React.createContext({
    tasks       : [] ,
    setTasks    : (data)=>{},
    isLoggedIn  : false ,
    token       : null ,
    setLoggedIn : (status)=> {} ,
    addNewTask  : (newTasks)=>{} ,
});
export const TasksContextProvider =(props)=>{ 
    let [tasks ,setTasks] = useState([]); 
    let [isLoggedIn ,setLoggedIn] =useState(localStorage.getItem("Logged_in"));
    
   let addNewTaskHandler =(newTasks)=>{
      setTasks((prevTasks)=>{
        return [newTasks, ...prevTasks];
      });
   };
   //
  //  let setFetchedTasks =(tasksList)=>{
  //   setTasks(tasksList);
  //  };
   return(
    <TasksContext.Provider
      value={{
        tasks :tasks ,
        setTasks :setTasks,
        token:localStorage.getItem("token"),
        addNewTask :addNewTaskHandler,
        isLoggedIn :isLoggedIn ,
        setLoggedIn :setLoggedIn ,
    }}>
        {props.children}
    </TasksContext.Provider>
   )
};
export default TasksContext;
